/* ScratchFix LP — JS minimo.
   Substitui os 42 scripts (~540 KB) da versao Netlify, que incluiam
   axios 3x, clipboard 2x, swiper, webpush, reviews e um Clarity de terceiro. */
(function () {
  'use strict';

  /* ---------- Galeria ---------- */
  var gal = document.querySelector('.sfx-gal');
  if (gal) {
    var track = gal.querySelector('.sfx-gal__track');
    var counter = gal.querySelector('[data-sfx-counter]');
    var thumbs = [].slice.call(gal.querySelectorAll('[data-sfx-thumb]'));
    var slides = track ? track.children.length : 0;
    var current = -1;

    var sync = function () {
      if (!track || !slides) return;
      var i = Math.round(track.scrollLeft / track.clientWidth);
      if (i === current) return;
      current = i;
      if (counter) counter.textContent = (i + 1) + '/' + slides;
      thumbs.forEach(function (t, n) {
        t.setAttribute('aria-current', n === i ? 'true' : 'false');
      });
    };

    if (track) {
      var raf;
      track.addEventListener('scroll', function () {
        if (raf) return;
        raf = requestAnimationFrame(function () { raf = null; sync(); });
      }, { passive: true });
    }

    thumbs.forEach(function (t) {
      t.addEventListener('click', function () {
        var i = +t.dataset.sfxThumb;
        track.scrollTo({ left: i * track.clientWidth, behavior: 'smooth' });
      });
    });
  }

  /* ---------- Video: so carrega no clique ---------- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-sfx-video]');
    if (!btn || btn.dataset.sfxLoaded) return;
    btn.dataset.sfxLoaded = '1';
    var v = document.createElement('video');
    v.src = btn.dataset.sfxVideo;
    v.controls = true;
    v.playsInline = true;
    v.autoplay = true;
    v.preload = 'auto';
    btn.innerHTML = '';
    btn.appendChild(v);
    var p = v.play();
    if (p && p.catch) p.catch(function () { v.controls = true; });
  });

  /* ---------- Variante: atualiza preco ---------- */
  var priceNow = document.querySelector('.sfx-price__now');
  var yen = function (cents) {
    return Math.round(cents / 100).toLocaleString('ja-JP');
  };

  document.addEventListener('change', function (e) {
    var input = e.target.closest && e.target.closest('[data-sfx-variant]');
    if (!input || !priceNow) return;
    priceNow.innerHTML = '<small>¥</small>' + yen(+input.dataset.price);

    /* preco estampado no CTA acompanha o bundle escolhido */
    var ctaPrice = document.querySelector('[data-sfx-cta-price]');
    if (ctaPrice) ctaPrice.textContent = '¥' + yen(+input.dataset.price);

    var wasEl = document.querySelector('.sfx-price__was');
    var cmp = +input.dataset.compare;
    if (wasEl) {
      if (cmp > +input.dataset.price) {
        var s = wasEl.querySelector('s');
        var off = wasEl.querySelector('.sfx-price__off');
        if (s) s.textContent = '¥' + yen(cmp);
        if (off) off.textContent = Math.round((cmp - input.dataset.price) / cmp * 100) + '% OFF';
        wasEl.style.display = '';
      } else {
        wasEl.style.display = 'none';
      }
    }
  });

  /* ---------- AddToCart no submit ----------
     Dispara junto com o clique, antes do POST. O InitiateCheckout/Purchase
     ficam a cargo do app Meta + Customer Events (nao duplicar aqui). */
  var form = document.getElementById('sfx-form');
  if (form) {
    form.addEventListener('submit', function () {
      var sel = form.querySelector('[data-sfx-variant]:checked');
      if (window.fbq && sel) {
        window.fbq('track', 'AddToCart', {
          content_ids: [sel.value],
          content_type: 'product_variant',
          value: +sel.dataset.price / 100,
          currency: window.SFX_CURRENCY || 'JPY'
        }, { eventID: 'atc-' + sel.value + '-' + Date.now() });
      }
      [].slice.call(document.querySelectorAll('[data-sfx-buy],[data-sfx-buy-inline]'))
        .forEach(function (btn) { btn.disabled = true; btn.style.opacity = '.6'; });
    });
  }

  /* ---------- Barra fixa: tira de qualquer ancestral que a prenda ----------
     position:fixed deixa de ser relativo a viewport se algum ancestral tiver
     transform/filter/will-change/contain — ai a barra cai no meio da pagina e
     some de vista. Pendurar direto no <body> elimina essa classe de problema
     de uma vez, independente do que o tema aplique nas secoes. */
  var bar = document.querySelector('.sfx-bar');
  if (bar && bar.parentNode !== document.body) document.body.appendChild(bar);
})();
